import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "../css/TextToPayInstructionsModal.css";
import Images from "assets/images/Images";
import { Button } from "react-bootstrap";

const RoundyModal = ({
  title,
  body,
  rightButtonText = "OK",
  leftButtonText = "Cancel",
  onRightButtonClick,
  onLeftButtonClick,
  showModal,
  closeModal,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(showModal);

  const onClickOrDefault = (onClickHandler) => {
    if (onClickHandler) onClickHandler();
    else setModalIsOpen(false);
  };

  useEffect(() => {
    setModalIsOpen(showModal);
  }, [showModal]);

  return (
    <>
      <Modal
        className="modal-spacing"
        show={modalIsOpen}
        onHide={() => onClickOrDefault(closeModal)}
      >
        <Modal.Header closeButton style={{ backgroundColor: "#366898" }}>
          <Modal.Title className="text-light" style={{ fontSize: "16px" }}>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="small">{body}</Modal.Body>
        <div className="d-flex justify-content-end">
          {<img src={Images.halfRoundy} alt="Roundy" />}
        </div>
        <Modal.Footer>
          <Button
            className="btn-decline"
            onClick={() => onClickOrDefault(onLeftButtonClick)}
          >
            {leftButtonText}
          </Button>
          <Button
            className="btn btn-primary-grad"
            onClick={() => onClickOrDefault(onRightButtonClick)}
          >
            {rightButtonText}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default RoundyModal;
